import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {DialogService} from '../../../../services/dialog/dialog.service';
import {Partner} from '../../../../models/partner/partner';
import {Paginator} from '../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../tools/table-sorter/table-sorter';
import {PartnerService} from '../../../../services/partner/partner.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import { DatePipe, NgClass, NgOptimizedImage } from '@angular/common';
import {TableSorterDirective} from '../../../../directives/table-sorter/table-sorter.directive';
import {forkJoin} from 'rxjs';
import {UserService} from '../../../../services/user/user.service';
import {User} from '../../../../models/user';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableSorterHeaderDirective} from '../../../../directives/table-sorter/table-sorter-header.directive';
import {PaginatorComponent} from '../../../layout/paginator/paginator.component';
import {RouterLink} from '@angular/router';
import {IsGrantedDirective} from '../../../../directives/is-granted/is-granted.directive';
import {ImageService} from '../../../../services/image/image.service';
import {MetaTitle} from '../../../../decorator/meta-title';
import {TranslatePipe} from '@ngx-translate/core';
import {PartnerDuplicateComponent} from '../partner-form/partner-duplicate/partner-duplicate.component';
import {InputSwitchComponent} from '../../../layout/input-switch/input-switch.component';
import {ListFilters} from '../../../../tools/list-filters/list-filters';
import {ListFilterService} from '../../../../services/list-filter/list-filter.service';

@Component({
  selector: 'app-partner-list',
  imports: [
    TableSorterDirective,
    NgClass,
    NgOptimizedImage,
    ReactiveFormsModule,
    FormsModule,
    TableSorterHeaderDirective,
    PaginatorComponent,
    RouterLink,
    IsGrantedDirective,
    RouterLink,
    DatePipe,
    TranslatePipe,
    InputSwitchComponent
],
  templateUrl: './partner-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-list.component.scss'
})
@MetaTitle('Partners')
export class PartnerListComponent implements OnInit {
  users: User[] = [];
  partners: Partner[] = [];
  paginator: Paginator = new Paginator();
  tableSorter: TableSorter = new TableSorter('id', 'asc');

  filters: ListFilters;

  constructor(
    protected partnerService: PartnerService,
    protected imageService: ImageService,
    private dialog: DialogService,
    private loader: LoaderService,
    private userService: UserService,
    private listFilterService: ListFilterService,
  ) {
    this.filters = listFilterService.createFilters({
      search: 'string',
      accountManagerId: 'string',
      accountType: 'string',
      state: 'string',
      prospect: 'boolean',
    }, this.paginator, this.tableSorter);
  }

  ngOnInit(): void {
    this.loader.startLoading();

    forkJoin([
      this.userService.findAll({accountManager: true, sort: 'firstname,lastname'})
    ]).subscribe(([users]) => {
      this.users = users;

      this.loader.stopLoading();
    });

    this.filters.init(() => this.fetchAll());
  }

  refresh(): void {
    this.fetchAll();
  }

  fetchAll(): void {
    this.loader.startLoading();

    const params: any = {groups: 'accountManager,image,contacts', ...this.filters.toParams()};

    this.partnerService.findAll(params, this.paginator, this.tableSorter).subscribe((partners: Partner[]) => {
      this.partners = partners;

      this.loader.stopLoading();
    });
  }

  duplicate(partner: Partner): void {
    this.dialog.openDialog(PartnerDuplicateComponent, {
      data: {
        partner
      },
      backdrop: false
    }).subscribe(() => {
      this.fetchAll();
    });
  }
}
